module.exports = __webpack_public_path__ + "assets/img/qq.a435f8e5.png";